import React from 'react';
import styled from 'styled-components';
import { useSearchState } from '@hotelplan/fdr.lib.search.with-state';
import { sx2CssThemeFn } from '@hotelplan/util.theme.sxc';
import {
  FdrFilterTags,
  FILTER_TAG_HEIGHT,
} from 'fdr/components/candidate/fdr-filters/fdr-filter-tags';
import { IFdrFiltersFormState } from 'fdr/components/candidate/fdr-search/types/filters.types';
import { IWishlistState } from 'fdr/components/local/fdr-wishlist/fdr-wishlist.types';

const FilterTagsWrapper = styled(FdrFilterTags)(
  sx2CssThemeFn({
    p: 0,
    px: [null, 4],
    mt: [3, null],
    mb: [null, 3],
    border: 'none',
    '.removableTag': {
      height: '100%',
      minHeight: `${FILTER_TAG_HEIGHT}px`,
    },
  })
);

const WishlistFiltersOverview: React.FC = () => {
  const {
    state: { filters },
    setState,
  } = useSearchState<IWishlistState>();

  const onChange = (nextFilters: IFdrFiltersFormState | null): void => {
    setState(prev => ({
      ...prev,
      filters: nextFilters || {},
    }));
  };

  if (!filters) return null;

  return <FilterTagsWrapper lines={3} filters={filters} onChange={onChange} />;
};

export default WishlistFiltersOverview;
